import { useState, useCallback } from "react";
import { useSnackbar } from "notistack";
import useAjax from "@apis/useAjax";
import {
	GET_MEMBER_PROFILE_API,
	GET_MEMBERS_MEMBERSID_ONSITE_ORDERS,
	GET_MEMBERS_MEMBERSID_UNCHECKOUT_ORDERS,
	GET_MEMBER_PROFILE_TIP_API,
	POST_MEMBER_PROFILE_PROTEIN_PUSH_API,
	POST_MEMBER_PROFILE_PROBIOTICS_PUSH_API,
	POST_MEMBER_PROFILE_CALCIUM_PUSH_API,
	POST_MEMBER_PROFILE_HUNDRED_T_SHIRT_API,
	POST_MEMBER_PROFILE_MEASURE_DAY_API,
	POST_MEMBER_PROFILE_NOTES_API,
	POST_MEMBER_PROFILE_TASKS_API,
	PUT_MEMBER_PROFILE_TASKS_API,
	DELETE_MEMBER_PROFILE_TASKS_API,
	GET_MEMBER_PROFILE_BASIC_API,
	POST_MEMBER_PROFILE_BASIC_API,
	GET_MEMBER_PROFILE_PAYMENTS_API,
	GET_MEMBER_PROFILE_PAYMENTS_MEMBERSHIP_API,
	POST_MEMBER_PROFILE_PAYMENTS_MEMBERSHIPS_API,
	GET_MEMBER_PROFILE_PAYMENTS_INVOICES_API,
	POST_MEMBER_PROFILE_PAYMENTS_INVOICES_API,
	PUT_MEMBER_PROFILE_NOTIFY_SMS_API,
	PUT_MEMBER_PROFILE_NOTIFY_MARKETING_ACTION_API,
	GET_MEMBER_PROFILE_HEALTH_DECLARATION_API,
	GET_MEMBER_PAYMENTS_OPTIONS_API,
	GET_MEMBER_PROTEINPUSH_OPTIONS_API,
	GET_MEMBER_PROBIOTICSPUSH_OPTIONS_API,
	GET_MEMBER_CALCIUMPUSH_OPTIONS_API, 
	POST_MEMBER_PROFILE_SMART_RING_PUSH_API, 
	GET_MEMBER_LINE_BINDING_INFO_API,
	DELETE_MEMBER_LINE_BINDING_INFO_API,
} from "@apis/apiPath";
import { isEmpty } from "@util/utils";

export const useMemberProfileApi = () => {
	const Ajax = useAjax();
	const { enqueueSnackbar } = useSnackbar();

	// 取得會員履歷
	const getMemberProfileApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBER_PROFILE_API(memberID));
			if (!resp) {
				enqueueSnackbar("讀取會員摘要失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberProfileOrderApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBERS_MEMBERSID_ONSITE_ORDERS(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberUncheckoutOrderApi = useCallback(
		async memberID => {
			let result = {};
			let resp = await Ajax.get(GET_MEMBERS_MEMBERSID_UNCHECKOUT_ORDERS(memberID));
			if (resp) result = Object.assign(result, { orderData: resp });
			return result;
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberProfileTipApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBER_PROFILE_TIP_API(memberID));
			if (!resp) {
				enqueueSnackbar("讀取會員摘要失敗,請再操作一次", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員蛋白循環推進
	const postMemberProfileProteinPushApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_PROTEIN_PUSH_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員鈣循環推進
	const postMemberProfileCalciumPushApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_CALCIUM_PUSH_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員益菌循環推進
	const postMemberProfileProbioticsPushApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_PROBIOTICS_PUSH_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const postMemberProfileSmartRingPushApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_SMART_RING_PUSH_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員百T尺吋
	const postMemberProfileHundredTShirtApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_HUNDRED_T_SHIRT_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員量身日
	const postMemberProfileMeasureDayApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_MEASURE_DAY_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員激勵因子項目來源、約定項目來源、指導注意、備註
	const postMemberProfileNotesApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_NOTES_API(memberID), parameters);

			if (resp) {
				enqueueSnackbar("已更新", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("更新失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 新增/更新待辦工作項目(待辦事項、服銷待辦事項)
	const postMemberProfileTasksApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_TASKS_API(memberID), parameters, {
				isLoadingVisible: false,
			});

			if (!resp) {
				enqueueSnackbar("新增失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	//更新切換待辦事項狀態(未選->完成 / 完成->未選)
	const putMemberProfileTasksApi = useCallback(
		async (memberID, parameters) => {
			let { taskID } = parameters;
			let resp = await Ajax.put(PUT_MEMBER_PROFILE_TASKS_API(memberID, taskID), parameters);

			if (!resp) {
				enqueueSnackbar("更新失敗", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除待辦事項
	const deleteMemberProfileTasksApi = useCallback(
		async (memberID, taskID) => {
			let resp = await Ajax.delete(DELETE_MEMBER_PROFILE_TASKS_API(memberID, taskID));

			if (resp) {
				enqueueSnackbar("已刪除", {
					variant: "success",
				});
			} else {
				enqueueSnackbar("刪除失敗", {
					variant: "error",
				});
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得會員基本資料
	const getMemberProfileBasicApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBER_PROFILE_BASIC_API(memberID));

			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員基本資料
	const postMemberProfileBasicApi = useCallback(
		async (memberID, parameters, callbackfn) => {
			const resp = await Ajax.post(POST_MEMBER_PROFILE_BASIC_API(memberID), parameters, { callbackfn });
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 會員付款資訊清單
	const getMemberProfilePaymentsApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBER_PROFILE_PAYMENTS_API(memberID));
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 會員會籍付款資訊清單
	const getMemberProfilePaymentsMembershipApi = useCallback(
		async (memberID, paymentID) => {
			let resp = await Ajax.get(GET_MEMBER_PROFILE_PAYMENTS_MEMBERSHIP_API(memberID, paymentID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會籍信用卡付款資訊
	const postMemberPaymentMembershipApi = useCallback(
		async (memberID, params) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_PAYMENTS_MEMBERSHIPS_API(memberID), params);
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null;
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 會員發票資訊清單
	const getMemberProfileInvoicesApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_PROFILE_PAYMENTS_INVOICES_API(memberID));

			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員發票資訊
	const postMemberProfileInvoicesApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_PAYMENTS_INVOICES_API(memberID), parameters);
			if (!isEmpty(resp) && resp.isError && typeof resp.result === "string") return null; // 排除 0002 錯誤
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員簡訊發送狀態Flag
	const putMemberProfileNotifySmsApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.put(PUT_MEMBER_PROFILE_NOTIFY_SMS_API(memberID), parameters);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 更新會員行銷發送狀態Flag
	const putMemberProfileNotifyMarketingActionApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.put(PUT_MEMBER_PROFILE_NOTIFY_MARKETING_ACTION_API(memberID), parameters);
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 取得是否有健康申告書PDF API
	const getMemberProfileHealthDeclarationApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBER_PROFILE_HEALTH_DECLARATION_API(memberID));
			if (!resp) {
				enqueueSnackbar("讀取健康申告書PDF有誤,請重新整理", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 付款Dialog初始資料
	const getInitMemberPaymentDataApi = useCallback(
		async memberID => {
			let sourceData = {};
			const optResp = await getMemberPaymentOptionsApi(memberID);
			if (optResp) {
				Object.assign(sourceData, { options: optResp.paymentTypeOptions });
			}
			const paymentsInfoData = await getMemberProfilePaymentsApi(memberID);
			if (paymentsInfoData) {
				Object.assign(sourceData, { paymentsInfoData: paymentsInfoData });
			}
			return sourceData;
		},
		// eslint-disable-next-line
		[]
	);

	// 付款方式options
	const getMemberPaymentOptionsApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_PAYMENTS_OPTIONS_API(memberID));
			if (!resp) {
				enqueueSnackbar("付款方式讀取有誤，請重新再操作一次", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 銷售益菌options
	const getMembersProbioticsOptionsApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_PROBIOTICSPUSH_OPTIONS_API(memberID));
			if (!resp) {
				enqueueSnackbar("益菌讀取有誤，請重新再操作一次", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 銷售蛋白options
	const getMembersProteinOptionsApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_PROTEINPUSH_OPTIONS_API(memberID));
			if (!resp) {
				enqueueSnackbar("蛋白讀取有誤，請重新再操作一次", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 銷售蛋白options
	const getMembersCalciumOptionsApi = useCallback(
		async memberID => {
			const resp = await Ajax.get(GET_MEMBER_CALCIUMPUSH_OPTIONS_API(memberID));
			if (!resp) {
				enqueueSnackbar("蛋白讀取有誤，請重新再操作一次", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getMemberProfileApi,
		getMemberProfileOrderApi,
		getMemberUncheckoutOrderApi,
		getMemberProfileTipApi,
		postMemberProfileProteinPushApi,
		postMemberProfileProbioticsPushApi,
		postMemberProfileCalciumPushApi,
		postMemberProfileSmartRingPushApi,
		postMemberProfileHundredTShirtApi,
		postMemberProfileMeasureDayApi,
		postMemberProfileNotesApi,
		postMemberProfileTasksApi,
		putMemberProfileTasksApi,
		deleteMemberProfileTasksApi,
		getMemberProfileBasicApi,
		postMemberProfileBasicApi,
		getMemberProfilePaymentsApi,
		getMemberProfilePaymentsMembershipApi,
		postMemberPaymentMembershipApi,
		getMemberProfileInvoicesApi,
		postMemberProfileInvoicesApi,
		putMemberProfileNotifySmsApi,
		putMemberProfileNotifyMarketingActionApi,
		getMemberProfileHealthDeclarationApi,
		getMembersProbioticsOptionsApi,
		getMembersProteinOptionsApi,
		getMembersCalciumOptionsApi,
		getMemberPaymentOptionsApi,
		getInitMemberPaymentDataApi,
	};
};

// 待辦工作項目(待辦事項、服銷待辦事項)
export const useMemberProfileTasksApi = () => {
	const [payload, setPayload] = useState();
	const Ajax = useAjax();
	const { enqueueSnackbar } = useSnackbar();

	// 新增/更新待辦工作項目(待辦事項、服銷待辦事項)
	const postMemberProfileTasksApi = useCallback(
		async (memberID, parameters) => {
			let resp = await Ajax.post(POST_MEMBER_PROFILE_TASKS_API(memberID), parameters, {
				isLoadingVisible: false,
			});

			if (resp) {
				setPayload(resp);
			} else {
				enqueueSnackbar("新增失敗", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	//更新切換待辦事項狀態(未選->完成 / 完成->未選)
	const putMemberProfileTasksApi = useCallback(
		async (memberID, parameters) => {
			let { taskID } = parameters;
			let resp = await Ajax.put(PUT_MEMBER_PROFILE_TASKS_API(memberID, taskID), parameters, {
				isLoadingVisible: false,
			});

			if (resp) {
				setPayload(resp);
			} else {
				enqueueSnackbar("更新失敗", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	// 刪除待辦事項
	const deleteMemberProfileTasksApi = useCallback(
		async (memberID, taskID) => {
			let parameters = { memberID, taskID };
			let resp = await Ajax.delete(DELETE_MEMBER_PROFILE_TASKS_API(memberID, taskID), parameters, {
				isLoadingVisible: false,
			});

			if (resp) {
				setPayload(resp);
				enqueueSnackbar("已刪除", { variant: "success" });
			} else {
				enqueueSnackbar("刪除失敗", { variant: "error" });
			}
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		payload,
		postMemberProfileTasksApi,
		putMemberProfileTasksApi,
		deleteMemberProfileTasksApi,
	};
};

// 會員網站綁定功能
export const useMemberProfileLineApi = () => {
	const Ajax = useAjax();
	
	const getLineBindingInfoApi = useCallback(
		async memberID => {
			let resp = await Ajax.get(GET_MEMBER_LINE_BINDING_INFO_API(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	const deleteLineBindingInfoApi = useCallback(
		async memberID => {
			let resp = await Ajax.delete(DELETE_MEMBER_LINE_BINDING_INFO_API(memberID));
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getLineBindingInfoApi,
		deleteLineBindingInfoApi
	}
}